import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHeart = () => {
  return (
    <g>
      <path d="M11.834 1c1.105 0 2.164.453 2.945 1.259A4.362 4.362 0 0 1 16 5.296a4.37 4.37 0 0 1-1.058 2.86l-.163.177-6.244 6.438a.74.74 0 0 1-.986.076l-.085-.076L1.22 8.333c-1.627-1.678-1.627-4.397 0-6.074A4.075 4.075 0 0 1 6.95 2.1l.161.158.889.915.888-.915A4.102 4.102 0 0 1 11.834 1zm0 1.5c-.634 0-1.247.237-1.729.668l-.14.135L8.502 4.81a.7.7 0 0 1-1.005 0L6.034 3.303a2.578 2.578 0 0 0-3.737 0c-1.018 1.05-1.06 2.741-.127 3.845l.127.14 5.702 5.881 5.704-5.881a2.854 2.854 0 0 0 .79-1.789l.007-.203c0-.751-.288-1.469-.798-1.993a2.602 2.602 0 0 0-1.868-.803z" />
    </g>
  );
};

export default withIcon(IconHeart);
